// this mixin is used for both add-balance (purchase/summary.vue) and in-game (in-game/summary.vue) components

import links from '@/config/links';

export default {
	computed: {
		isKarmaKoinSelectedAndOption() {
			return this.selectedPg && this.selectedPg.methodName === 'karmakoin' && this.karmakoinSelectedOption;
		},
		purchaseSummary() {
			return this.$store.state.purchaseSummaryData;
		},
		products() {
			if (this.isKarmaKoinSelectedAndOption) {
				return [
					{
						productId: this.$store.state.productsData[0].productId,
						name: `${this.$n(this.karmakoinSelectedOption.amount)} NX`,
						amount: this.karmakoinSelectedOption.amount,
						currency: this.karmakoinSelectedOption.currency,
						value: this.karmakoinSelectedOption.nx,
						quantity: 1,
						productType: 'nxwallet',
					},
				];
			}
			return this.$store.state.productsData;
		},
		currency() {
			if (this.isKarmaKoinSelectedAndOption) {
				return this.karmakoinSelectedOption.currency;
			}
			return this.purchaseSummary.currency;
		},
		tax() {
			if (this.isKarmaKoinSelectedAndOption) {
				return this.karmakoinSelectedOption.taxAmount;
			}
			return this.purchaseSummary.taxAmount;
		},
		showSalesTax() {
			if (this.isKarmaKoinSelectedAndOption) {
				return this.karmakoinSelectedOption.hasTax;
			}
			return this.purchaseSummary.hasSalesTax;
		},
		total() {
			if (this.isKarmaKoinSelectedAndOption) {
				return this.karmakoinSelectedOption.totalAmount;
			}
			return this.purchaseSummary.totalAmount;
		},
		supportLink() {
			return links[this.region].supportLink;
		},
		digitalLicenseTerms() {
			return links[this.region].digitalLicenseTerms(this.$i18n.locale);
		},
		tobenDigitalLicenseTerms() {
			return links[this.region].tobenDigitalLicenseTerms(this.$i18n.locale);
		},
		selectedPg() {
			return this.$store.state.selectedPg;
		},
		isRefundable() {
			return this.selectedPg && this.selectedPg.isRefundable;
		},
		karmakoinSelectedOption() {
			return this.$store.state.karmakoinSelectedOption;
		},
		serviceCode() {
			return this.$store.state.purchaseSummaryData.serviceCode;
		},
		serviceType() {
			return this.$store.state.purchaseSummaryData.serviceType;
		},
		mileage() {
			return this.$store.state.mileage;
		},
	},
};
